import { type FragmentOf, graphql, readFragment } from "@opensea/graphql"
import {
  CardFooterBadge,
  TextLabel,
  Tooltip,
  TooltipLabel,
} from "@opensea/ui-kit"
import { StacksFilled } from "@opensea/ui-kit/icons"
import { useTranslations } from "next-intl"

type Props = {
  item: FragmentOf<typeof QuantityBadgeFragment> | undefined
}

export const QuantityBadgeFragment = graphql(`
  fragment QuantityBadge on Item {
    bestListing {
      quantityRemaining
    }
    totalSupply
  }
`)

export function QuantityBadge({ item: itemKey }: Props) {
  const item = readFragment(QuantityBadgeFragment, itemKey)
  const quantityRemaining = item?.bestListing?.quantityRemaining
  const totalSupply = item?.totalSupply
  const t = useTranslations("ItemCardQuantityBadge")

  return quantityRemaining && totalSupply ? (
    <Tooltip
      content={
        <TooltipLabel>
          {`${quantityRemaining.toLocaleString()}/${totalSupply.toLocaleString()} ${t("listed")}`}
        </TooltipLabel>
      }
      disabled={!totalSupply}
    >
      <CardFooterBadge className="gap-1">
        <StacksFilled size={13} />
        <TextLabel>{quantityRemaining}</TextLabel>
      </CardFooterBadge>
    </Tooltip>
  ) : null
}
